
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Check } from 'lucide-react';

const MobileAppsAssessment = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ist eine mobile App das Richtige für Ihr Unternehmen?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Finden Sie heraus, ob eine native App Ihren Geschäftszielen dienen kann
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="border-2 border-blue-200 bg-white">
            <CardContent className="p-8">
              <ul className="space-y-5">
                <li className="flex items-start">
                  <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-lg font-semibold mb-1">Möchten Sie Ihr Kundenerlebnis verbessern und die Kundenbindung stärken?</p>
                    <p className="text-gray-600">Eine App bietet direkten Zugang zu Ihren Produkten und Services – immer griffbereit auf dem Smartphone.</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-lg font-semibold mb-1">Benötigen Ihre Mitarbeiter mobilen Zugriff auf Unternehmensressourcen?</p>
                    <p className="text-gray-600">Eine Business-App kann Ihrem Team den Zugriff auf wichtige Daten und Prozesse von überall ermöglichen.</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-lg font-semibold mb-1">Wollen Sie Ihre Marke stärken und im digitalen Raum präsenter sein?</p>
                    <p className="text-gray-600">Eine App schafft täglich mehrere Berührungspunkte mit Ihrer Marke und stärkt Ihre Markenwahrnehmung.</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-lg font-semibold mb-1">Möchten Sie von Funktionen wie Push-Benachrichtigungen und Offline-Zugriff profitieren?</p>
                    <p className="text-gray-600">Native Apps bieten Zugriff auf Gerätefunktionen, die über Web-Anwendungen nicht oder nur eingeschränkt verfügbar sind.</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <Check className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-lg font-semibold mb-1">Suchen Sie nach neuen Umsatzquellen oder Monetarisierungsmöglichkeiten?</p>
                    <p className="text-gray-600">Apps können durch In-App-Käufe, Abonnements oder erweiterte Funktionen zusätzliche Einnahmequellen erschließen.</p>
                  </div>
                </li>
              </ul>
              
              <div className="mt-8 p-4 bg-blue-50 rounded-md text-center">
                <p className="text-lg font-medium text-blue-800">
                  Wenn Sie mindestens drei dieser Fragen mit „Ja" beantwortet haben, könnte eine mobile App eine lohnende Investition für Ihr Unternehmen sein.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default MobileAppsAssessment;
